import { uniq, flatten, find } from "lodash";
import { AppConstants } from "../constants/AppConstants";
import environment from "../environment";

export const getLoggedInRolePermissionSet = (
  permissionSet: any,
  loggedInRole: string
) => {
  let instanceObject: any;
  instanceObject = find(permissionSet, (permissionObj) => {
    const { attributes } = permissionObj;
    const { roles = [] } = attributes;
    if (roles.length && roles.includes(loggedInRole)) {
      return permissionObj;
    }
  });

  return instanceObject?.attributes?.permissions || [];
};

export const getAdminPortalFeatures = (featuresInstanceList: any) => {
  const adminPortalFeatureObject: any = {
    features: [],
  };

  featuresInstanceList.forEach((instance: any) => {
    const { attributes } = instance;
    const { active = true } = attributes;
    if (active) {
      adminPortalFeatureObject.features.push(instance.attributes);
    }
  });

  return adminPortalFeatureObject;
};

export const getPermittedItems = (
  menuArray: Array<any> = [],
  permsArray: Array<any> = [],
  permissions: any,
  appendData: boolean = false
) => {
  let tempArray: any = [];

  const menuArrayApiPermission: any = new Map(
    menuArray.map((item) => [
      item?.name,
      uniq(
        flatten(item.functions.map((feature: any) => feature.permissions)).map(
          (apiPermissions: any) => apiPermissions.claim
        )
      ),
    ])
  );

  const featureAccessMap = new Map(
    permsArray.map((item: any) => [
      item?.feature,
      (tempArray = (item?.function || item?.functions)?.map(
        (e: any) => e?.action
      )),
    ])
  );

  const permitedItems: any = menuArray.filter((menuItem: any) => {
    const { name } = menuItem;
    if (featureAccessMap.get(name)) {
      if (featureAccessMap.get(name).includes("All")) {
        let isServiceAvailable = true;
        menuArrayApiPermission.get(name).forEach((featurePermission: any) => {
          if (!permissions[featurePermission]) {
            isServiceAvailable = false;
          }
        });
        if (isServiceAvailable) {
          return menuItem;
        }
      } else {
        //This block is for future changes for feature granular level like checking permission for list, create, edit etc
      }
    }
  });

  return [...permitedItems];
};

export const returnErrorPage = () => {
  const namespace = sessionStorage.getItem("namespace");
  const clientName = localStorage.getItem("clientName");

  if (namespace === "" || clientName === "") {
    return true;
  }
  return false;
};


export const  setFavIcon = () => {
  let link: any = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
  link.href = AppConstants.getLogoIconUrl();
};
